import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, output, signal, viewChild } from '@angular/core';
import { Address, AddressProducts } from '@mwe/models';
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { GetAddressPostCodeAndStreetPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'mwe-address-with-selection-dropdown',
  templateUrl: './address-with-selection-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgClass,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    GetAddressPostCodeAndStreetPipe,
    TranslatePipe,
  ],
})
export class AddressWithSelectionDropdownComponent {
  address = input.required<Address>();
  addressOptions = input.required<AddressProducts[]>();

  readonly newAddressSelected = output<AddressProducts>();
  isCollapsed = signal<boolean>(true);
  dropdown = viewChild(NgbDropdown);

  destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      this.dropdown()
        ?.openChange?.pipe(
          takeUntilDestroyed(this.destroyRef),
          tap(isOpen => this.isCollapsed.set(!isOpen)),
        )
        .subscribe();
    });
  }

  closeDropDown(): void {
    this.dropdown()?.close();
  }

  isAddressSelected(address: Address): boolean {
    return address.hashCode === this.address().hashCode;
  }

  onAddressSelected(addressProducts: AddressProducts): void {
    this.newAddressSelected.emit(addressProducts);
  }
}
